/**
 * Returns a list with auxiliaries for the Italian passive voice assessment.
 * @returns {Array} The list with auxiliaries.
 */
export default function() {
	return [
		"fui",
		"fu",
		"fosti",
		"fummo",
		"foste",
		"furono",
		"stato",
		"stati",
		"stata",
		"state",
		"venire",
		"vengo",
		"vieni",
		"viene",
		"veniamo",
		"venite",
		"vengono",
		"venivo",
		"venivi",
		"veniva",
		"venivamo",
		"venivate",
		"venivano",
		"verrò",
		"verrai",
		"verrà",
		"verremo",
		"verrete",
		"verranno",
		"venni",
		"venisti",
		"venne",
		"venimmo",
		"veniste",
		"vennero",
		"verrei",
		"verresti",
		"verrebbe",
		"verremmo",
		"verreste",
		"verrebbero",
		"venga",
		"veniamo",
		"venite",
		"vengano",
		"veniate",
		"venissi",
		"venisse",
		"venissimo",
		"veniste",
		"venissero",
		"andare",
		"vado",
		"vai",
		"va",
		"andiamo",
		"andate",
		"vanno",
		"andavo",
		"andavi",
		"andava",
		"andavamo",
		"andavate",
		"andavano",
		"vada",
		"andiate",
		"andante",
		"andato",
		"andassi",
		"andasse",
		"andassimo",
		"andaste",
		"andassero",
		"andai",
		"andasti",
		"andò",
		"andammo",
		"andarono",
		"andrò",
		"andrai",
		"andrà",
		"andremo",
		"andrete",
		"andranno",
		"andrei",
		"andresti",
		"andrebbe",
		"andremmo",
		"andreste",
		"andrebbero",
		"vadano",
		"andando",
	];
}
